import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const PackageBuilder: React.FC = () => {
  return (
    <PageTemplate
      title="Package Builder"
      description="Build deployment packages for your metadata"
    />
  );
};